<template>
  <div>
    <p class="social-dialog-ttl">
      <b
        >かんたん３ステップ<br />
        まずは会員登録</b
      >
    </p>
    <ol class="step-bar push-top push-bottom">
      <li class="visited"><span class="select">1</span><br />登録</li>
      <li><span>2</span><br />決済</li>
      <li><span>3</span><br />完了</li>
    </ol>
    <registration-buttons
      :additional-params="additionalParams"
      :email-registration-url="emailRegistrationUrl"
      :last-login-method="lastLoginMethod"
    />
  </div>
</template>

<script>
import RegistrationButtons from './RegistrationButtons';

export default {
  components: { RegistrationButtons },
  props: {
    additionalParams: Object,
    emailRegistrationUrl: String,
    lastLoginMethod: { type: String, default: null },
  }
};
</script>
